<template>
  <ul>
    <li :class="{'active': !!item.isOpen, 'highlight': !!item.isOpen && (!item.children || !item.children.length) && open.includes(item.categoryId)}" @click.stop="select(item)">
      <p class="content" :style="{'padding-left': item.ids ? 10 * (item.ids.length - 1) + 'px' : '10px'}">
        <span class="desc">{{item.name}}</span>
        <tooltips :visible="false" :text="item.name"></tooltips>
      </p>
      <i class="iconfont" :class="{'icon-rule-arrow-down': !item.isOpen, 'icon-rule-arrow-up': !!item.isOpen}" v-if="item.children && item.children.length" @click.stop="$emit('toggle', item)"></i>
      <template v-if="item.isOpen">
        <ListTree v-for="(item2, index2) in item.children" :key="'2-' + index2" :item="item2" @select="select" :open="open" @toggle="toggle"></ListTree>
      </template>
    </li>
  </ul>
</template>

<script>
import tooltips from './tooltips.vue'
export default {
  name: 'ListTree',
  props: {
    item: Object,
    open: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    select (item) {
      this.$emit('select', item)
    },
    toggle (item) {
      this.$emit('toggle', item)
    }
  },
  components: {
    tooltips
  }
}
</script>

<style lang="scss" scoped>
ul {
  li {
    position: relative;
    display: none;
    line-height: 30px;
    .content {
      margin-left: 16px;
      padding-right: 25px;
      span.desc {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .ui-tooltips {
        position: absolute;
      }
      &:hover {
        .ui-tooltips {
          display: block!important;
          z-index: 9999;
          white-space: nowrap;
        }
      }
    }
    i {
      position: absolute;
      right: 20px;
      top: 7px;
      line-height: 18px;
      font-weight: bold;
    }
  }
  &.active {
    li {
      display: block;
      color: #666;
      font-weight: 400;
      // background: rgba($color: #F1F1F3, $alpha: 0.2);
      &.highlight {
        background: #F1F1F3;
        border-left: 4px solid #F10180;
      }
      &.active {
        > ul {
          // background: #F1F1F3;
        }
      }
    }
  }
}
</style>
